import { useCallback, useState } from 'react';

const STORAGE_KEY = 'workforce-ui.theme';

type Theme = 'dark' | 'light';

const readTheme = (): Theme => (localStorage.getItem(STORAGE_KEY) === 'light' ? 'light' : 'dark');

const applyTheme = (theme: Theme) => {
  document.documentElement.classList.toggle('dark', theme === 'dark');
};

export const useTheme = () => {
  const [theme, setTheme] = useState<Theme>(() => {
    const initial = readTheme();
    applyTheme(initial);
    return initial;
  });

  const toggleTheme = useCallback(() => {
    setTheme((current) => {
      const next: Theme = current === 'dark' ? 'light' : 'dark';
      localStorage.setItem(STORAGE_KEY, next);
      applyTheme(next);
      return next;
    });
  }, []);

  return { theme, toggleTheme };
};
